import SignupForm from '../../../components/Auth/SignupForm';
import './SignupAuthForm.css';
import './signup.css';

const SignupPage = () => {
    return (
        <div className="signupPage">
            <SignupForm />
        </div>
    );
};

export default SignupPage;
